import type { LabelValueOption } from './self-service-config.types';

/**
 * Widgets of a PUBLISHED / saved dashboard a table cell (or popup button) can
 * target with its navigation filter — read from the dashboard's layout JSON
 * (`pageContent` rows, or every tab's `pageContent`). Input controls (slider /
 * input box / dropdown) are skipped: a row filter has nothing to do to them.
 *
 * Shared by the Layout Builder and the Design Builder hosts so the Navigation
 * accordion's "Target components" picker lists the same widgets in both.
 */
export function navTargetComponentOptionsFromLayout(config: Record<string, unknown> | null | undefined): LabelValueOption[] {
  const options: LabelValueOption[] = [];
  const seen = new Set<string>();
  const collectFromPage = (pageContent: unknown): void => {
    if (!Array.isArray(pageContent)) return;
    pageContent.forEach((row) => {
      const cols = (row as Record<string, unknown>)?.['columns'];
      if (!Array.isArray(cols)) return;
      cols.forEach((widget) => {
        const w = widget as Record<string, unknown>;
        const id = String(w?.['componentId'] ?? '').trim();
        const type = String(w?.['type'] ?? '');
        const isInput = type === 'slider' || type === 'input-box' || type === 'dropdown';
        if (id && !isInput && !seen.has(id)) {
          seen.add(id);
          options.push({ label: String(w?.['title'] ?? id), value: id });
        }
      });
    });
  };
  if (!config) return options;
  collectFromPage(config['pageContent']);
  const tabs = config['tabs'];
  if (Array.isArray(tabs)) tabs.forEach((tab) => collectFromPage((tab as Record<string, unknown>)?.['pageContent']));
  return options;
}

/** True when a layout JSON carries renderable content a target picker can read. */
export function layoutHasNavTargets(config: Record<string, unknown> | null | undefined): boolean {
  return !!config && (!!config['pageContent'] || !!config['tabs']);
}
